<template>
<div>
    <div v-for="(task, index) in allItems" :key="index" >
        <b-card class="modal-task">

            <div class="webview" v-if="Object.keys(task.goal).length == 0">
            <div class="row">
                <div class="col-8 col-sm-8 col-md-5 col-lg-5 col-xl-5">
                    <div class="task-title">
                    <span class="counter_task-list__counter"></span>
                    {{ task.description }}
                    </div>
                </div>
                <div class="col-3 col-sm-3 col-md-4 col-lg-5 col-xl-5">
                    <a href="javascript:void(0)" class="task_goal_text" @click="openModal(task, 'add')" v-if="subTaskId != 99999">Set Goal</a>
                </div>
                <div class="col-4 col-sm-4 col-md-3 col-lg-2 col-xl-2">
                    <button class="btn btn-primary btn-sm dbAddRepsBtn" @click="openAddRepetitionModal(task)" v-if="(task.completed === 0)">
                        Add Rep
                    </button>
                    <button class="btn btn-primary btn-sm dbAddRepsBtnCompleted" @click="openAddRepetitionModal(task)" v-else-if="(task.completed === 1)">
                        <b><i class="fa fa-check"  aria-hidden="true"></i></b> or Add Rep
                    </button>
                </div>
            </div>
            </div>
            <div v-else>
                <div class="webview">
                    <div class="row">
                        <div class="col-8 col-sm-8 col-md-5 col-lg-5 col-xl-5">
                            <div class="task-title">
                            <span class="counter_task-list__counter"></span>
                            {{ task.description }}
                            </div>
                        </div>
                        
                        <div v-if="task.goal.defaultGoalId > 0 && task.goal.id == ''" class="col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1 task_goal_text">
                            <a href="javascript:void(0)" class="task_goal_text default_goal" @click="openDefaulGoalModal(task)">Edit</a>
                        </div>
                        <div v-else class="col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1 task_goal_text">
                            <a href="javascript:void(0)" class="task_goal_text" @click="openModal(task, 'edit')">Edit</a>
                        </div>

                        <div class="col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1 task_goal_text">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                        <div class="col-3 col-sm-2 col-md-2 col-lg-2 col-xl-2 task_goal_text" style="padding-right: 5px;">{{ calchoursonly(task.goal.task_hours) + '/ ' + task.goal.goal_hours + ' Task Hours' }}</div>
                        <div class="col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1 task_goal_text" v-if="task.goal.completion_date != '01/01/1970'" style="padding-right: 5px; padding-left: 5px;">{{ task.goal.completion_date }} </div>
                        <div class="col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1 task_goal_text" style="padding-right: 5px; padding-left: 5px;" v-else>No Due Date</div>
                        <div class="col-md-2 col-lg-2 col-xl-2">
                        <button class="btn btn-primary btn-sm dbAddRepsBtn" @click="openAddRepetitionModal(task)" v-if="(task.completed === 0)">
                            Add Rep
                        </button>
                        <button class="btn btn-primary btn-sm dbAddRepsBtnCompleted" @click="openAddRepetitionModal(task)" v-else-if="(task.completed === 1)">
                        <b><i class="fa fa-check"  aria-hidden="true"></i></b> or Add Rep
                    </button>
                        </div>
                    </div>
                </div>
                <div class="mobileview">
                    <div class="row">
                        <div class="col-7 col-sm-9 col-md-9">
                            <div class="task-title">
                            <span class="counter_task-list__counter"></span>
                            {{ task.description }}
                            </div>
                        </div>
                        <div class="col-5 col-sm-3 col-md-3">
                        <button class="btn btn-primary btn-sm dbAddRepsBtn" @click="openAddRepetitionModal(task)">
                            + Rep
                        </button>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="task.goal.defaultGoalId > 0 && task.goal.id == ''" class="col-3 col-sm-3 col-md-3 task_goal_text">
                            <a href="javascript:void(0)" class="task_goal_text default_goal" @click="openDefaulGoalModal(task)">Edit</a>
                        </div>
                        <div v-else class="col-3 col-sm-3 col-md-3 task_goal_text">
                            <a href="javascript:void(0)" class="task_goal_text" @click="openModal(task, 'edit')">Edit</a>
                        </div>

                        <div class="col-3 col-sm-3 col-md-3 task_goal_text">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                        <div class="col-3 col-sm-3 col-md-3 task_goal_text">{{ calchoursonly(task.goal.task_hours) + '/ ' + task.goal.goal_hours + ' Task Hours' }}</div>
                        <div class="col-3 col-sm-3 col-md-3 task_goal_text">{{ task.goal.completion_date }} </div>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
    <div v-if="allItems.length == 0 && subTaskId == 99999" class="no-other-tasks">
        No other task added
    </div>
    <AddRepetition
        :isModalVisible="isRepsModalVisible"
        :menteeId="menteeId"
        :tasklistId="tasklistId"
        :subTaskId="subTaskId"
        :headingId="headingId"
        :searchText="searchText"
        :originFrom="originFrom"
        goalSNo=""
        ref="add_reps_form"
        @close="isRepsModalVisible = false">
    </AddRepetition>
    <AddGoal 
        :isModalVisible="isGoalModal"
        :modal_title="modalTitle" 
        :submit_value="submitValue"
        :menteeId="menteeId"
        :tasklistId="tasklistId"
        :subTaskId="subTaskId"
        :headingId="headingId"
        :searchText="searchText"
        :originFrom="originFrom"
        ref="add_goal_form"
        @close="isGoalModal = false">
    </AddGoal>
    <AddDefaultGoal 
        :isModalVisible="isDefaultGoalModal"
        :modal_title="modalTitle" 
        :submit_value="submitValue"
        :menteeId="menteeId"
        :tasklistId="tasklistId"
        :subTaskId="subTaskId"
        :headingId="headingId"
        :searchText="searchText"
        :originFrom="originFrom"
        ref="add_default_goal_form"
        @close="isDefaultGoalModal = false">
    </AddDefaultGoal>
</div>
</template>
<script>
import AddRepetition from './add_repetition.vue';
import AddGoal from './add_goal.vue';
import AddDefaultGoal from './add_mentee_goal_from_mentee_goal.vue';

export default {
    props: ['allItems', 'itemLength', 'menteeId', 'tasklistId', 'subTaskId', 'headingId', 'searchText', 'originFrom'],
    data() {
        return {
            isGoalModal: false,
            isRepsModalVisible: false,
            modalTitle: '',
            completionDate: '',
            hours: '',
            repCount: '',
            taskHours: '',
            taskRepCount: '',
            goalId: '',
            submitValue: '',
            taskGoal: [],
            isDefaultGoalModal: false,
        }
    },
    components: {
        AddGoal,
        AddRepetition,
        AddDefaultGoal,
    },
    methods: {
        calchoursonly: function(minutes) {
            var hours = (minutes / 60);
            var rhours = Math.floor(hours);
            var min = (hours - rhours) * 60;
            var rminutes = Math.round(min);
            if(rminutes > 0) {
                return rhours + " hr. " + rminutes + " min ";
            }
            else {
                return rhours + " hr. ";
            }
        },
        openAddRepetitionModal(args) {
            this.isRepsModalVisible = true;
            const vmessage = 'hide_vmessage';
            this.$refs.add_reps_form.getScoreLists(args, vmessage);
        },
        openModal(args, formType) {
            this.isGoalModal = true;
            const vmessage = 'hide_vmessage';
            this.$refs.add_goal_form.getTaskItem(args, vmessage);
            if (formType == "edit") {
                this.modalTitle = "Edit Goals";
                this.submitValue = "Save";
            } else {
                this.modalTitle = "Add Goals";
                this.submitValue = "Set Goals";
            }
        },
        openDefaulGoalModal(args) {
            this.isDefaultGoalModal = true;
            const vmessage = 'hide_vmessage';
            this.$refs.add_default_goal_form.getTaskItem(args, vmessage);
            this.modalTitle = "Edit Goals";
            this.submitValue = "Save";
        },
    }
}
</script>
<style scoped>
.dbAddRepsBtn, .dbAddRepsBtn:active, .dbAddRepsBtn:focus {
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: normal;
  padding: 6px 10px;
  line-height: 10px;
  width: 100%;
}
.dbAddRepsBtnCompleted, .dbAddRepsBtnCompleted:active, .dbAddRepsBtnCompleted:focus {
  color: #FFF !important;
  background-color: #4E8D23 !important;
  border: 1px solid #4E8D23 !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: normal;
  padding: 6px 10px;
  line-height: 10px;
  width: 100%;
}

.task_goal_text {
  color:#00acee;
  text-align: left;
  font-weight: normal;
}
.task-title { padding: 0px; cursor: default !important; }
.set_goal_list { padding: 10px; }
/* Small Devices */
@media (min-width: 320px) and (max-width: 576px) { 
  .webview { display: none; }
  .mobileview { display: block; padding: 10px; }
  .task_goal_text { margin-top: 10px; }
}
/* Medium Devices */
@media (min-width: 601px) and (max-width: 768px) { 
  .webview { display: none; }
  .mobileview { display: block; padding: 10px; }
  .task_goal_text { margin-top: 10px; }
}
/* Large Devices */
@media (min-width: 809px) and (max-width: 1024px) { 
  .mobileview { display: none; }
  .webview { display: block; padding: 10px 10px 10px 20px; }
  .task_goal_text { margin-top: 5px; }
}
/* Extra Large Devices */
@media (min-width: 1200px) {
  .mobileview { display: none; }
  .webview { display: block; padding: 10px 10px 10px 20px; }
  .task_goal_text { margin-top: 5px; }
  
}
.no-other-tasks {
    font-style: italic;
    font-size: 14px;
    text-align: center;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/mentee_task_list.vue